import { Button } from '@unmind/design-system';
import { styled } from 'styled-components';

export const GetHelpNowButton = styled(Button)`
  &&.get-help-now-button {
    margin-left: auto;
  }
`;
